@if (projectId(); as currentProjectId) {
  <div>
    <div class="sticky top-[52px] z-20 bg-(--surface-card) pb-3 pe-3 ps-6 pr-6 mb-3 rounded-lg">
      <app-progress-dashboard
        [attributesByEvaluationCriteria]="dashboardAttributesByCriteria()"
        [evaluationCriteria]="dashboardDirectusCriteria()"
        [evaluationSubCriteria]="dashboardDirectusSubCriteria()"
        phase="RFP"
      />
    </div>
    <div class="flex items-end justify-between gap-5">
      <app-global-search
        class="mt-4 mb-4"
        testId="step-6-1-search"
        (searchValue)="onSearchChanged($event)"
      />
      <app-contributor-menu-bar
        [projectId]="currentProjectId"
        [showAverageOption]="true"
        dotMenuTestId="step8-1-dot-menu-button"
        [preselectedRole]="contributorRole"
        [preselectedAccessiblePages]="[rfpEvaluationSubcriteria]"
        (contributorSelected)="onContributorSelected($event)"
      />
    </div>
    @if (loading()) {
      <app-loading />
    } @else if (!hasCriteria()) {
      <div class="text-center py-8" data-testid="no-evaluation-criteria-message">
        <p>{{ 'project.steps.noEvaluationCriteria' | transloco }}</p>
      </div>
    } @else if (showNoSearchResults()) {
      <div class="text-center py-8" data-testid="no-search-results-message">
        <p>{{ 'project.steps.evaluationCriteria.noSearchResults' | transloco }}</p>
      </div>
    } @else {
      <p-tabs
        appTabsUnsavedReveal
        [value]="activeTabValue()"
        (valueChange)="onTabSelected($event!)"
        class="evaluation-criteria-tabs"
        scrollable
      >
        <p-tablist>
          @for (criteria of filteredCriteria(); track criteria.id; let i = $index) {
            <p-tab
              [value]="criteria.id"
              [appTabStatus]="criteria.status"
              [appTabStatusUnsaved]="filteredCriteriaUnsaved()[i]"
            >
              {{ criteria.translations | translateDirectus }}
              @if (showConsistency() && criteria.unresolvedConsistencyCount > 0) {
                <i
                  class="pi pi-exclamation-triangle ml-2 text-sm"
                  [style.color]="
                    criteria.clarificationConsistencyCount > 0
                      ? consistencyClarificationColor
                      : consistencyWarningColor
                  "
                  [pTooltip]="'evaluation.consistency.tabWarning' | transloco"
                  [attr.data-testid]="'evaluation-criteria-tab-warning-' + criteria.id"
                ></i>
              }
            </p-tab>
          }
          <p-tab [value]="summaryTabValue" [appTabStatus]="summaryTabStatus()">
            {{ 'project.steps.summary' | transloco }}
          </p-tab>
        </p-tablist>
        <p-card data-testid="chapter8-step1-card" class="mt-6">
          <p-tabpanels>
            @for (criteria of filteredCriteria(); track criteria.id) {
              <p-tabpanel [value]="criteria.id">
                @if (openedTabValues().has(criteria.id)) {
                  <div class="flex justify-between items-center mb-6">
                    <h2 class="text-2xl font-bold">
                      {{ criteria.translations | translateDirectus }}
                    </h2>
                  </div>
                  <app-evaluation-criteria-tab
                    [criteria]="criteria"
                    [projectId]="currentProjectId"
                    [disabled]="isDisabled()"
                    [ec3ModuleTabs]="tabEc3ModuleTabs()"
                    [showConsistency]="showConsistency()"
                    (saved)="onTabSaved($event)"
                    (consistencyChanged)="onConsistencyChanged($event)"
                    (unsavedScoresChanged)="onTabUnsavedScoresChanged(criteria.id, $event)"
                  />
                }
              </p-tabpanel>
            }
            <p-tabpanel [value]="summaryTabValue">
              @if (openedTabValues().has(summaryTabValue)) {
                <div class="flex justify-between items-center mb-6">
                  <h2 class="text-2xl font-bold">{{ 'project.steps.summary' | transloco }}</h2>
                </div>
                <app-step-6-1-evaluation-criteria-comparison-summary
                  [criteria]="comparableCriteria()"
                />
              }
            </p-tabpanel>
          </p-tabpanels>
        </p-card>
      </p-tabs>
      @if (canFinishStep()) {
        <div class="flex justify-end mt-4">
          <p-button
            [label]="'project.finish.step.label' | transloco"
            (onClick)="finishStep()"
            data-testid="finish-evaluation-button"
            [disabled]="isFinishingStep()"
          ></p-button>
        </div>
      }
    }
  </div>
}
